// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"528":"codemirror","909":"notifications","961":"returns"}[chunkId] || chunkId) + "." + {"483":"168739c6668b31827041","487":"d7d9d856c01510622d01","528":"dde3c144f64b968161e7","909":"9b09a0d30fba0e589da5","961":"5a1ceb09c100b9518a1c"}[chunkId] + ".js";
};